import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'grecoJoin' })
export class GrecoJoinPipe implements PipeTransform {
  transform<T>(value: T[], joinWith: string): string {
    return value ? (Array.isArray(value) ? value : [value]).join(joinWith || '') : '';
  }
}
